import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('gym_token'));
  const [user, setUser]   = useState(() => {
    try {
      const u = localStorage.getItem('gym_user');
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  });
  const [impersonating, setImpersonating] = useState(() => {
    return !!localStorage.getItem('gym_original_token');
  });

  const login = useCallback((newToken, newUser) => {
    localStorage.removeItem('gym_original_token');
    localStorage.removeItem('gym_original_user');
    localStorage.setItem('gym_token', newToken);
    localStorage.setItem('gym_user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
    setImpersonating(false);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('gym_token');
    localStorage.removeItem('gym_user');
    localStorage.removeItem('gym_original_token');
    localStorage.removeItem('gym_original_user');
    setToken(null);
    setUser(null);
    setImpersonating(false);
  }, []);

  const impersonate = useCallback((targetToken, targetUser) => {
    localStorage.setItem('gym_original_token', token);
    localStorage.setItem('gym_original_user', JSON.stringify(user));
    localStorage.setItem('gym_token', targetToken);
    localStorage.setItem('gym_user', JSON.stringify(targetUser));
    setToken(targetToken);
    setUser(targetUser);
    setImpersonating(true);
  }, [token, user]);

  const stopImpersonating = useCallback(() => {
    const originalToken = localStorage.getItem('gym_original_token');
    const originalUser = localStorage.getItem('gym_original_user');
    if (originalToken && originalUser) {
      localStorage.setItem('gym_token', originalToken);
      localStorage.setItem('gym_user', originalUser);
      localStorage.removeItem('gym_original_token');
      localStorage.removeItem('gym_original_user');
      setToken(originalToken);
      setUser(JSON.parse(originalUser));
    }
    setImpersonating(false);
  }, []);

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ token, user, login, logout, impersonate, stopImpersonating, impersonating, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
